export const VEHICLE_STATUSES = [
  'Initiation',
  'Launchpad',
  'Submission',
  'Compliance',
  'Resubmission',
  'Vaulted',
];

export const ENTRY_STATUS = {
  submitted: 'SUBMITTED',
  success: 'SUCCESS',
  failed: 'FAILED',
};

const document_category_usmca_invoice = 'USMCA Invoice';
const document_category_usmca_certificate = 'USMCA Certificate of Origin';

export const DOCUMENT_CATEGORIES_USMCA = [
  document_category_usmca_invoice ,
  document_category_usmca_certificate,
];